/**
 * Starting point offered when a document type is added to a workflow, as rendered by
 * `GET /api/workflow-catalog`. `documentTypeKey` null is the generic preset applied to a type with
 * no dedicated one. Prompts are `''` when the preset has none.
 */
export type DocumentTypePresetPayload = {
	readonly documentTypeKey: string | null;
	readonly systemPrompt: string;
	readonly contextPrompt: string;
	readonly reevaluationSystemPrompt: string;
	readonly reevaluationContextPrompt: string;
	readonly splitCalls: boolean;
	readonly sectionDependencies: Record<string, string[]>;
};

export type WorkflowCatalogFetchedAction = {
	type: 'WORKFLOW_CATALOG_FETCHED';
	// `DocumentTypePresetPayload[]`, never `readonly …[]`: synapse's `DefaultPayload` requires an
	// `Array<Record<string, unknown>>`.
	payload: DocumentTypePresetPayload[];
};

export default (payload: DocumentTypePresetPayload[]): WorkflowCatalogFetchedAction => ({
	type: 'WORKFLOW_CATALOG_FETCHED',
	payload,
});
